let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jQdF8")).then(() => parcelRequire('btQ2m'));